import { render, staticRenderFns } from "./ObiApp.vue?vue&type=template&id=77fe0e1a&scoped=true&"
import script from "./ObiApp.vue?vue&type=script&lang=js&"
export * from "./ObiApp.vue?vue&type=script&lang=js&"
import style0 from "./ObiApp.vue?vue&type=style&index=0&id=77fe0e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe0e1a",
  null
  
)

export default component.exports